import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVerticalAlignBottomComponent } from "./med-icon-vertical-align-bottom.component";

@NgModule({
  declarations: [
    MedIconVerticalAlignBottomComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVerticalAlignBottomComponent,
  ],
})
export class MedIconVerticalAlignBottomModule { }
